import { connect } from "react-redux";
import InsufficientSelectionNotice from "./InsufficientSelectionNotice";

const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    leaderGateScope: state.BenchmarkFilteringReducer.leaderGateScope,
});

export default connect(mapStateToProps)(InsufficientSelectionNotice);
